import { CustomModal } from "@/components/custom-modal";
import { Button } from "@/components/ui/button";
import {
  DialogClose,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ToastMessage, type } from "@/lib/toastr";
import { changeRole, updateLimit } from "@/services/Settings.service";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ChevronLeft, ChevronRight, Loader2, SquarePen, UserPlus } from "lucide-react";
import { useState } from "react";
import { useForm } from "react-hook-form";

const UpdateLimitAmount = ({ data }: any) => {
  const [open, setOpen] = useState(false)
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (payload: unknown) => await updateLimit(payload),
    mutationKey: ["updateLimit"],
    onSuccess: (res) => {
      console.log(res.data);
      queryClient.invalidateQueries({ queryKey: ["currencies"] });
      setOpen(false)
      ToastMessage(type.SUCCESS, "Currency limit updated successfully");
      // handleDialogItemOpenChange(false);
    },
    onError: (err: any) => {

      ToastMessage(type.ERROR, err.response.data.message);
    },
  });

  const form = useForm();

  const onSubmit = async (formData: any) => {
    const payload = {
      currency: data?.code,
      minDeposit: Number(formData?.minDeposit),
      minSwap: data?.currency?.minSwap
    }
    console.log(payload);
    await mutation.mutate(payload);
  };

  console.log(data);
  return (
    <CustomModal
      button={
        <Button className="ring-transparent"
          variant='ghost'
        >
          <SquarePen />
        </Button>
      }
      open={open}
      onOpenChange={setOpen}
      size='sm'
    >

      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="flex flex-col gap-8">
            <DialogHeader className="flex flex-row  w-full p-0 items-center gap-4 bg-off-white-1 py-6 px-8 rounded-t-[16px]">
              {/* <div className="flex items-center justify-center w-12 h-12 rounded-full bg-off-white-3">
                <UserPlus />
              </div> */}
              {/* <div className="flex flex-col "> */}
              <DialogTitle className="text-sm font-normal capitalize text-primary-3">
                Update amount
              </DialogTitle>
              {/* <DialogDescription className="text-sm">
                  Reassign a role to an existing team member
                </DialogDescription>
              </div> */}
            </DialogHeader>
            <div className="flex flex-col gap-4 px-8 pb-8">
              <FormField
                control={form.control}
                name="minDeposit"
                render={({ field }) => {
                  return (
                    <FormItem>
                      <div className="flex flex-col w-full items-start gap-1 border-[1px] rounded-[8px] px-2 py-2 h-[52px] border-input-border-2">

                        <FormLabel htmlFor="role" className="text-xs">
                          Minimum Deposit amount
                        </FormLabel>

                        <FormControl>

                          <div className="flex w-full items-center justify-between gap-3">
                            <Input
                              className="p-0 border-none bg-transparent rounded-none h-6 w-full "
                              // onChange={(e) => setSelectedAmount(e?.target?.value)}
                              placeholder="Enter Amount"
                              // value={selectedAmount === 0 ? "" : selectedAmount}
                              type='number'
                              defaultValue={data?.currency?.minDeposit?.toString()}
                              {...field}
                            />

                            {data?.code && (
                              <span className="text-sm text-gray-dark w-fit text-right">
                                {data?.code?.toLocaleUpperCase()}{" "}
                                {/* {selectedFee} Fee */}
                              </span>
                            )}
                          </div>
                        </FormControl>
                      </div>

                    </FormItem>
                  );
                }}
              />
            </div>
          </div>
          <DialogFooter className="px-6 py-4 flex flex-row justify-between items-center bg-off-white-1 rounded-b-[16px]">
            <DialogClose asChild>
              <Button
                type="button"
                variant="ghost"
                className=" text-primary0 h-12 rounded-[10px] p-[8px 12px] hover:text-primary0"
              >
                <ChevronLeft /> Cancel
              </Button>
            </DialogClose>
            <Button
              type="submit"
              className="bg-gradient-to-r from-primary to-primary-2 h-12 rounded-[10px] p-[8px 12px]"
              disabled={
                mutation.isPending
              }
            //  !form.formState.isDirty ||
            //   !form.formState.isValid ||
            //   form.formState.isSubmitting ||
            >
              {mutation.isPending && (
                <Loader2 className="text-white animate-spin" />
              )}
              Save Changes
            </Button>
          </DialogFooter>
        </form>
      </Form>
    </CustomModal>
  );
};

export default UpdateLimitAmount;
